"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[182],{

/***/ 20182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var NotListing = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "h-1/2 flex justify-center items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
            className: "text-2xl",
            children: "Currently no listings match your search."
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotListing);


/***/ })

}]);